(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nyxis-core"] && !Shopify.designMode) return;
  try {
    
const nyxisServiceSelect = document.querySelector('[data-service-select]');
if (nyxisServiceSelect) {
  const requestedTier = new URLSearchParams(location.search).get('tier');
  if (requestedTier) nyxisServiceSelect.value = requestedTier.toUpperCase();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyxis-home-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){var button=event.target.closest('[data-nyxis-spell]');if(!button)return;var data={perfect:['Controlled radiance','Polished surfaces, exact detail, and a restrained moment of delight.',['Cool reflective material','Precise tactile object','Quiet celebratory note']],bad:['Soft recovery','Comfort without cliché, gentle tactility, and room to exhale.',['Warm tactile layer','Restorative daily object','A note without forced optimism']],again:['Clean threshold','Clarity, movement, and renewed permission.',['Crisp functional form','Symbol of transition','Bright restrained color']],777:['Charged coincidence','Coded repetition and a little private electricity.',['Numbered object','Reflective accent','Secret symbolic note']]};document.querySelectorAll('[data-nyxis-spell]').forEach(function(el){el.classList.remove('active')});button.classList.add('active');var value=data[button.dataset.nyxisSpell];document.querySelector('[data-nyxis-title]').textContent=value[0];document.querySelector('[data-nyxis-copy]').textContent=value[1];document.querySelector('[data-nyxis-cues]').innerHTML=value[2].map(function(item){return '<li>'+item+'</li>'}).join('')})

  } catch(e) { console.error(e); }
})();
})();
